module.exports = __webpack_public_path__ + "img/allDd.afe4a09e.png";